var _rect, _circle, _circle2, _circle3, _path, _path2, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _circle15, _circle16, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _circle17, _circle18, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _ellipse, _path38, _path39, _path40, _path41;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainScreenImg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 739 905",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 739,
    height: 905,
    rx: 10,
    fill: "#FAFAFB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 472.391,
    cy: 447.787,
    r: 1.843,
    fill: "#23024D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 215.843,
    cy: 423.843,
    r: 1.843,
    fill: "#23024D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 188.843,
    cy: 121.843,
    r: 1.843,
    fill: "#23024D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.475 105.82l2.688 9.859.076.276.275.075 9.86 2.689-9.86 2.689-.275.075-.076.275-2.688 9.859-2.69-9.859-.074-.275-.276-.075-9.859-2.689 9.859-2.689.276-.075.075-.276 2.689-9.859z",
    fill: "#23024D",
    stroke: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.654 123.897l2.467 2.467M73.531 126.775l.822.823M74.766 128.008l.822.822M60.049 113.292l-2.467-2.466M57.172 110.414l-.822-.822M55.935 109.182l-.822-.823M70.897 113.292l2.466-2.466M73.777 110.415l.823-.822M75.01 109.182l.822-.823M60.291 123.897l-2.466 2.467M57.412 126.775l-.822.823M56.18 128.009l-.822.822",
    stroke: "#000"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 250.571,
    cy: 531.483,
    r: 2.303,
    fill: "#23024D"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 679.5,
    cy: 727.5,
    r: 5.5,
    transform: "rotate(-180 679.5 727.5)",
    fill: "#23024D"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 628.264,
    cy: 668.04,
    r: 2.303,
    fill: "#23024D"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 417.575,
    cy: 484.178,
    r: 2.303,
    fill: "#23024D"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 285.831,
    cy: 595.655,
    r: 2.303,
    stroke: "#23024D"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.501,
    cy: 236.812,
    r: 1.843,
    fill: "#23024D"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 286.291,
    cy: 549.13,
    r: 2.264,
    stroke: "#23024D"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 388.764,
    cy: 326.764,
    r: 2.264,
    stroke: "#23024D"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 237.764,
    cy: 357.764,
    r: 2.264,
    stroke: "#23024D"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 507.764,
    cy: 440.764,
    r: 2.264,
    stroke: "#23024D"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 371.971,
    cy: 373.163,
    r: 2.264,
    fill: "#23024D",
    stroke: "#1127E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M568.16 50.177l-3.924-14.39-14.39-3.925 14.39-3.924 3.924-14.39 3.925 14.39 14.39 3.924-14.39 3.925-3.925 14.39z",
    fill: "#5F0E8E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M561.752 25.451L558.7 22.4M558.191 21.89l-1.017-1.018M556.666 20.364l-1.017-1.017M574.879 38.577l3.052 3.053M578.438 42.139l1.017 1.017M579.965 43.664l1.017 1.017M561.447 38.577l-3.052 3.053M557.887 42.139l-1.018 1.017M556.359 43.665l-1.017 1.017M574.57 25.452l3.053-3.052M578.135 21.89l1.017-1.017M579.66 20.364l1.018-1.017",
    stroke: "#5F0E8E",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M555.207 228.945l-1.828-6.702-6.702-1.828 6.702-1.828 1.828-6.702 1.828 6.702 6.702 1.828-6.702 1.828-1.828 6.702z",
    fill: "#5F0E8E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M552.223 217.427l-1.422-1.422M550.561 215.771l-.474-.473M549.85 215.061l-.474-.474M558.334 223.543l1.422 1.422M559.99 225.202l.474.474M560.703 225.913l.474.474M552.082 223.542l-1.422 1.422M550.424 225.2l-.474.474M549.711 225.912l-.474.474M558.193 217.429l1.422-1.422M559.85 215.771l.474-.474M560.562 215.06l.474-.474",
    stroke: "#5F0E8E",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M586.172 145.492l-1.395-5.114-5.114-1.395 5.114-1.395 1.395-5.114 1.395 5.114 5.114 1.395-5.114 1.395-1.395 5.114z",
    fill: "#5F0E8E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M583.895 136.704l-1.085-1.085M582.629 135.439l-.362-.361M582.084 134.897l-.362-.361M588.559 141.37l1.084 1.085M589.824 142.636l.362.361M590.365 143.179l.362.361M583.785 141.369l-1.085 1.085M582.521 142.635l-.361.361M581.979 143.177l-.362.361M588.451 136.704l1.085-1.085M589.715 135.438l.361-.361M590.258 134.896l.361-.361",
    stroke: "#1127E9",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M368.564 179.753l-1.78-6.527-6.527-1.78 6.527-1.78 1.78-6.527 1.781 6.527 6.527 1.78-6.527 1.78-1.781 6.527z",
    fill: "#5F0E8E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M365.654 168.539l-1.384-1.384M364.041 166.923l-.461-.462M363.35 166.231l-.462-.461M371.609 174.492l1.385 1.385M373.223 176.107l.461.462M373.918 176.8l.461.461M365.516 174.492l-1.385 1.385M363.9 176.107l-.461.462M363.209 176.8l-.462.461M371.469 168.539l1.384-1.384M373.086 166.923l.461-.462M373.775 166.231l.462-.461",
    stroke: "#5F0E8E",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M386.904 72.47l-1.833-6.72-6.72-1.833 6.72-1.833 1.833-6.72 1.833 6.72 6.721 1.833-6.721 1.833-1.833 6.72z",
    fill: "#5F0E8E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M383.91 60.924l-1.425-1.426M382.246 59.26l-.475-.475M381.533 58.548l-.475-.475M390.041 67.054l1.426 1.425M391.701 68.718l.475.475M392.418 69.43l.475.475M383.771 67.052l-1.425 1.425M382.107 68.716l-.475.475M381.396 69.428l-.475.475M389.9 60.923l1.426-1.426M391.564 59.259l.476-.475M392.277 58.546l.476-.475",
    stroke: "#5F0E8E",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M666.203-116.84L567.732 32.064m0 0l18.569 106.761-31.511 82.6m12.942-189.361l-196.38 135.98L387.429 63.6l180.303-31.536z",
    stroke: "#B83FC3",
    strokeWidth: 5
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 457.246,
    cy: 108.834,
    r: 3.442,
    transform: "rotate(-180 457.246 108.834)",
    fill: "#5F0E8E"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 443.48,
    cy: 53.767,
    r: 3.442,
    transform: "rotate(-180 443.48 53.767)",
    fill: "#5F0E8E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M332.734 225.381c40.388-13.658 80.327-32.219 99.175-38.003 23.559-7.232 88.968-24.073 98.854 0 9.886 24.072-8.142 43.386-15.835 54.474-7.693 11.088-30.735 35.988-24.361 58.331 2.765 9.69 7.212 13.337 12.341 16.872 2.724 1.878 7.361-2.977 10.766-7.737 6.534-9.135 24.628-31.032 36.513-39.987 7.826-5.897 55.133-85.006 63.948-108.628 15.05-40.333 8.146-42.659 12.981-63.312 8.014-34.227 42.472-82.596 60.903-107.342l49.969-70.612M338.819 86.37c11.379-12.534 13.564-14.24 24.334-22.724 13.463-10.605 63.64-34.891 83.674-41.319 13.481-4.324 51.266-14.575 70.365-43.727 6.61-10.088 35.442-52.929 51.255-75.747l55.301-83.53",
    stroke: "#23024D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M339.333 85.793c-9.134 9.81-28.071 30.542-30.747 34.996-3.346 5.568-8.762 19.407-10.833 25.134-1.657 4.581-5.47 44.541-7.169 63.948l27.56 46.927c3.134.849 10.133 1.018 13.064-5.09 10.458-21.795-5.576-38.603-10.196-54.086 1.965-3.129 6.118-10.786 7.01-16.386.892-5.599 2.496-16.225 3.186-20.839l21.507-27.838",
    stroke: "#23024D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M298.812 224.6c-.527 5.683-1.581 17.982-1.581 21.714 0 4.664 4.428 40.372-6.959 51.309-6.881 6.61-14.655 4.236-18.345 3.217-1.212-12.063-3.542-39.182-3.163-51.148.475-14.959 0-52.758 0-58.548 0-5.791 6.326-30.239 12.968-39.729 6.642-9.49 21.508-20.749 21.508-20.749",
    stroke: "#23024D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M268.902 235.936c-7.171 11.809-29.654 34.178-40.209 40.209-9.27 5.298-30.156 6.164-30.156-3.498 0-9.662 19.907-21.095 32.43-35.749 3.369-3.943 23.058-28.054 37.935-46.196",
    stroke: "#23024D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M216.948 279.513c-.054.854 4.129 1.76 7.113 1.76 15.691 0 30.556-19.1 44.621-28.65m36.41-18.195l-7.539 3.518M605.842 69.685s-19.234-21.13-47.433-34.356c-28.198-13.227-50.366-17.42-50.366-17.42M494.307 149.075c13.073-7.713 33.916-27.13 12.702-43.088-21.213-15.96-56.473-12.82-71.452-9.256M345.811 161.732l-17.259 16.108M350.924 139.957l2.037-8.443c.783-3.247 3.448-7.144 2.664-11.203m-8.777 34.909c-.783.649-1.88 2.598 0 5.196a132.336 132.336 0 004.076 5.358m34.006 21.27c-2.351-.487-8.933-3.572-11.91-6.332-2.978-2.761-7.523-7.794-10.97-8.606",
    stroke: "#23024D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M374.576 181.291s-15.859 8.252-23.989 13.518c-8.131 5.265-23.883 15.997-23.883 15.997",
    stroke: "#23024D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M181.359 844.626l3.925 14.39 14.39 3.925-14.39 3.924-3.925 14.39-3.924-14.39-14.39-3.924 14.39-3.925 3.924-14.39z",
    fill: "#5F0E8E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M187.77 869.351l3.052 3.052M191.33 872.911l1.018 1.018M192.855 874.438l1.018 1.017M174.643 856.225l-3.053-3.053M171.082 852.664l-1.017-1.017M169.557 851.138l-1.018-1.018M188.074 856.227l3.053-3.053M191.637 852.665l1.017-1.017M193.162 851.139l1.018-1.018M174.951 869.351l-3.052 3.052M171.387 872.913l-1.018 1.018M169.861 874.438l-1.017 1.018",
    stroke: "#5F0E8E",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M194.314 665.857l1.828 6.703 6.703 1.827-6.703 1.828-1.828 6.703-1.827-6.703-6.703-1.828 6.703-1.827 1.827-6.703z",
    fill: "#5F0E8E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M197.297 677.376l1.422 1.422M198.959 679.031l.474.474M199.67 679.742l.474.474M191.189 671.259l-1.421-1.422M189.531 669.601l-.474-.474M188.818 668.89l-.474-.474M197.441 671.26l1.422-1.422M199.1 669.602l.474-.474M199.814 668.89l.474-.474M191.33 677.372l-1.422 1.422M189.674 679.03l-.474.474M188.961 679.742l-.474.474",
    stroke: "#5F0E8E",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M163.35 749.311l1.394 5.114 5.115 1.395-5.115 1.394-1.394 5.115-1.395-5.115-5.114-1.394 5.114-1.395 1.395-5.114z",
    fill: "#5F0E8E"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M165.631 758.099l1.085 1.084M166.895 759.363l.361.362M167.439 759.905l.362.362M160.965 753.433l-1.085-1.085M159.701 752.167l-.361-.362M159.158 751.624l-.361-.362M165.734 753.434l1.085-1.085M167 752.168l.362-.362M167.541 751.625l.362-.362M161.07 758.099l-1.085 1.084M159.805 759.364l-.362.362M159.262 759.906l-.362.362",
    stroke: "#5F0E8E",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M380.959 715.05l1.78 6.527 6.527 1.78-6.527 1.78-1.78 6.527-1.78-6.527-6.527-1.78 6.527-1.78 1.78-6.527z",
    fill: "#5F0E8E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M383.869 726.264l1.385 1.384M385.482 727.879l.462.461M386.174 728.571l.461.462M377.916 720.311l-1.385-1.385M376.301 718.695l-.462-.461M375.605 718.004l-.461-.462M384.008 720.311l1.384-1.385M385.623 718.695l.462-.461M386.316 718.003l.462-.462M378.053 726.264l-1.385 1.384M376.436 727.88l-.462.461M375.746 728.571l-.461.462",
    stroke: "#5F0E8E",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M362.615 822.332l1.833 6.721 6.721 1.833-6.721 1.833-1.833 6.721-1.833-6.721-6.721-1.833 6.721-1.833 1.833-6.721z",
    fill: "#5F0E8E"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M365.609 833.879l1.426 1.426M367.271 835.543l.476.475M367.984 836.255l.476.475M359.479 827.749l-1.426-1.426M357.818 826.085l-.475-.475M357.104 825.373l-.476-.475M365.752 827.75l1.426-1.426M367.416 826.086l.475-.475M368.127 825.373l.475-.475M359.623 833.879l-1.426 1.426M357.957 835.543l-.475.475M357.246 836.256l-.475.475",
    stroke: "#5F0E8E",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M83.316 1011.64l98.472-148.901m0 0l-18.569-106.761 31.511-82.6m-12.942 189.361l196.379-135.98-16.077 104.443-180.302 31.537z",
    stroke: "#B83FC3",
    strokeWidth: 5
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 292.278,
    cy: 785.968,
    r: 3.442,
    fill: "#5F0E8E"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 306.041,
    cy: 841.034,
    r: 3.442,
    fill: "#5F0E8E"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M416.791 669.411c-40.388 13.658-80.327 32.219-99.175 38.003-23.559 7.231-88.967 24.073-98.854 0-9.886-24.072 8.142-43.386 15.835-54.474 7.693-11.088 30.735-35.988 24.361-58.331-2.764-9.69-7.212-13.337-12.341-16.872-2.724-1.878-7.361 2.977-10.766 7.737-6.534 9.135-24.628 31.032-36.513 39.987-7.826 5.897-55.133 85.006-63.947 108.628-15.051 40.333-8.147 42.659-12.982 63.312-8.014 34.227-42.471 82.595-60.902 107.342l-49.97 70.612m399.169-166.932c-11.379 12.534-13.564 14.239-24.334 22.724-13.463 10.605-63.64 34.891-83.674 41.318-13.481 4.325-51.266 14.576-70.365 43.727-6.61 10.089-35.442 52.93-51.255 75.748l-55.301 83.53",
    stroke: "#23024D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M410.193 808.998c9.133-9.809 28.07-30.542 30.747-34.996 3.345-5.568 8.762-19.407 10.833-25.134 1.656-4.581 5.469-44.541 7.169-63.948l-27.561-46.927c-3.133-.848-10.132-1.018-13.064 5.09-10.458 21.795 5.576 38.603 10.196 54.086-1.965 3.129-6.117 10.786-7.009 16.386-.892 5.599-2.496 16.225-3.187 20.839l-21.506 27.838",
    stroke: "#23024D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M450.711 670.192c.527-5.683 1.582-17.982 1.582-21.714 0-4.664-4.428-40.372 6.958-51.309 6.882-6.61 14.655-4.236 18.345-3.217 1.213 12.063 3.543 39.181 3.163 51.148-.474 14.959 0 52.758 0 58.548 0 5.791-6.326 30.239-12.968 39.729-6.642 9.49-21.508 20.749-21.508 20.749",
    stroke: "#23024D"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M480.623 658.855c7.171-11.809 29.654-34.177 40.209-40.208 9.271-5.298 30.157-6.164 30.157 3.498 0 9.662-19.908 21.095-32.431 35.749-3.369 3.943-23.058 28.053-37.935 46.196",
    stroke: "#23024D"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M532.577 615.279c.054-.854-4.128-1.76-7.113-1.76-15.691 0-30.555 19.1-44.62 28.65m-36.41 18.195l7.539-3.518M143.684 825.106s19.233 21.13 47.432 34.356c28.199 13.227 50.366 17.42 50.366 17.42M255.22 745.717c-13.073 7.713-33.916 27.13-12.702 43.088 21.213 15.959 56.473 12.821 71.452 9.256M403.715 733.06l17.258-16.108M398.6 754.835l-2.037 8.443c-.784 3.247-3.448 7.144-2.665 11.203m8.777-34.909c.784-.649 1.88-2.598 0-5.196a132.648 132.648 0 00-4.075-5.358m-34.006-21.27c2.35.487 8.932 3.572 11.91 6.332 2.977 2.761 7.522 7.794 10.97 8.606",
    stroke: "#23024D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M374.951 713.501s15.859-8.252 23.989-13.518c8.131-5.265 23.883-15.997 23.883-15.997M467.564 512.076l6.221 3.592M478.971 518.661l16.071 9.279M500.744 531.231l16.071 9.279M288.395 311.439l3.591 6.221M294.977 322.846l9.278 16.071M307.551 344.619l9.278 16.071M264.742 425.873l-4.626-1.239M256.07 423.549l-12.142-3.254M239.879 419.211l-12.143-3.254M444.729 582.582l-2.395-4.147M440.238 574.807l-6.285-10.887M431.857 560.291l-6.285-10.887M235.203 377.696l16.071 9.279M256.975 390.268l16.07 9.278M449.836 533.539l13.122 13.122M467.615 551.317l13.122 13.122M290.229 373.932l-6.773-6.773M277.527 361.233l-18.201-18.201M252.98 336.684l-17.777-17.778M418.65 633.903l-2.479-9.251M414.004 616.557l-6.662-24.864M405.02 583.021l-6.508-24.286M476.898 483.146l39.897 10.691M331.318 307.707l10.691 39.897M275.115 512.078l-6.221 3.592M263.707 518.66l-16.071 9.279M241.936 531.231l-16.071 9.279M454.285 311.44l-3.592 6.221M447.697 322.845l-9.278 16.071M435.129 344.619l-9.279 16.071M477.938 425.873l4.625-1.239M486.609 423.549l12.143-3.254M502.801 419.211l12.142-3.254M297.951 582.582l2.395-4.147M302.441 574.807l6.286-10.887M310.822 560.291l6.286-10.887M507.475 377.697l-16.071 9.279M485.703 390.268l-16.071 9.278M292.842 533.54l-13.122 13.122M275.062 551.317l-13.121 13.122M452.447 373.932l6.773-6.773M465.148 361.233l18.202-18.201M489.695 336.684l17.778-17.778M324.029 633.903l2.479-9.251M328.676 616.557l6.662-24.864M337.66 583.021l6.507-24.286M265.781 483.146l-39.897 10.691M411.359 307.707l-10.69 39.897",
    stroke: "#23024D"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M171.111 450.962h387.518M579.699 450.962h32.98M160.117 450.962h-32.98M621.84 450.962h9.161M117.977 450.962h-9.162M366.439 720.405V197.428M366.439 168.992v-44.509M366.439 735.242v44.509M366.439 112.12V99.757M366.439 792.114v12.364",
    stroke: "#000636"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 366.439,
    cy: 452.695,
    rx: 84.335,
    ry: 83.758,
    fill: "#8620B9"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M366.442 595.372c39.559 0 71.627-31.81 71.627-71.05 0-39.239-32.068-71.05-71.627-71.05s-71.628 31.811-71.628 71.05M366.441 308.862c-39.559 0-71.627 31.81-71.627 71.05 0 39.24 32.068 71.05 71.627 71.05s71.627-31.81 71.627-71.05",
    stroke: "#23024D"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M366.442 595.372c-39.559 0-71.628-31.81-71.628-71.05M366.441 308.862c39.559 0 71.627 31.81 71.627 71.05",
    stroke: "#23024D",
    strokeDasharray: "4 3"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M377.553 445.595l15.402 15.318 15.294-15.219 6.713 6.638-22.005 21.897-15.404-15.319-24.289 24.156-13.033-12.962-15.602 15.517-6.711-6.641 22.313-22.19 13.033 12.961 24.289-24.156z",
    stroke: "#fff"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M377.553 419.77l15.402 15.317 15.294-15.219 6.713 6.639-22.005 21.896-15.404-15.319-24.289 24.156-13.033-12.962-15.602 15.517-6.711-6.641 22.313-22.19 13.033 12.961 24.289-24.155z",
    stroke: "#fff"
  })));
}
export default SvgMainScreenImg;